import { render, staticRenderFns } from "./BuildingInvoiceTable.vue?vue&type=template&id=de7d38c4&scoped=true&"
import script from "./BuildingInvoiceTable.vue?vue&type=script&lang=js&"
export * from "./BuildingInvoiceTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "de7d38c4",
  null
  
)

export default component.exports